export default __webpack_public_path__ + "static/media/csharp.040a443e.svg";